module.exports = __webpack_public_path__ + "img/p25.37ea955c.png";